import React from 'react'
import { NavDropdown } from 'react-bootstrap'

import type { PartialDeep } from 'type-fest'

import { useHistory } from '@ztechapps/common.hook'
import { useTrackEvent } from '@ztechapps/webui.telemetry'

import { routesDef } from '../../../config/routes'
import type { QueryFilter } from '../../../config/types'

type CategoryNavDropdownItemProps = { category: { value: string; label: string } } & PartialDeep<QueryFilter>

export const CategoryNavDropdownItem = ({ category, ...args }: CategoryNavDropdownItemProps) => {
  const trackEvent = useTrackEvent()
  const history = useHistory()

  return (
    <NavDropdown.Item
      key={category?.value}
      onClick={() => {
        trackEvent('Category filter', {
          category_label: category?.label,
          category_value: category?.value,
        })
        history.push(routesDef.ProductListPage.altPath({ ...args }))
      }}
    >
      {category?.label}
    </NavDropdown.Item>
  )
}
